import { IUserState, EUserTariffType } from '../../types/reducers/user';

/**
 * Получает тариф пользователя из биллинг-информации
 * 1 - некоммерческий
 * 2 - базовый
 * 3 - профи
 * 5 - застройщик
 * @returns тариф в виде id или null при его отсутствии
 */
export const getUserTariffs = (user: IUserState) => {
  let result: Array<EUserTariffType> = [];

  if (user && user.billingInfo && Array.isArray(user.billingInfo.packages)) {
    result = user.billingInfo.packages.map(({ packageTypeId }) => packageTypeId);
  }

  return result;
};
